<template>
    <div class="sau-bx bx-pad text-center">
        <img src="/img/illustrations/conversations.svg" width="200">
        <h4>Just one thing...</h4>
        <p>Before we can process your order we'll need to know more about you.<br> Update your profile to let us know who you are.</p>
        <a href="/account/update"  class="btn btn-success">Update Profile</a>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
}
</script>

<style>
</style>
